import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Swaps the page's web-app manifest so installing while on a /pos screen produces a
// dedicated POS app that opens straight to the PIN login, while the rest of the site
// still installs as the normal customer app.
const DEFAULT_MANIFEST = '/manifest.json';
const POS_MANIFEST = '/manifest.pos.json';

export function ManifestSwitcher() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isPos = pathname === '/pos' || pathname.startsWith('/pos/');
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.setAttribute('href', isPos ? POS_MANIFEST : DEFAULT_MANIFEST);

    const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (appleTitle) appleTitle.setAttribute('content', isPos ? 'The Tiffin POS' : 'The Tiffin');
    if (isPos) document.title = 'The Tiffin POS';
  }, [pathname]);

  return null;
}
